var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMedicalTip = function SvgMedicalTip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA82",
    d: "M24 35c8.008 0 14.5-6.492 14.5-14.5S32.008 6 24 6 9.5 12.492 9.5 20.5 15.992 35 24 35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA82",
    d: "M31 31H17v4h14z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M31 35H17v3h14z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M17 38h14c0 2.21-1.79 4-4 4h-4c-2.21 0-4-1.79-4-4Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8952",
    d: "M30.2 17.82a1.25 1.25 0 0 0-1.77 0l-4.41 4.41-4.45-4.45a1.25 1.25 0 0 0-1.77 0 1.25 1.25 0 0 0 0 1.77l4.95 4.95V35h2.5V24.54l4.95-4.95c.49-.49.49-1.28 0-1.77"
  })));
};
export default SvgMedicalTip;